import { Component } from '@angular/core';
import { Mediator } from '../_types/mediator';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { MediatorsService } from '../_services/mediators.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { UsersService } from '../../users/_services/users.service';

@Component({
    selector: 'app-mediators-list',
    templateUrl: './mediators-list.component.html',
    styleUrls: ['./mediators-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class MediatorsListComponent {
  public mediators: Mediator[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowDelete: boolean = false;

  constructor(
    private mediatorsService: MediatorsService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService,
    private usersService: UsersService
  ) { }

  ngOnInit(): void {
    this.topbarService.setTitle("Mediadores");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as Mediator);
    });
    this.allowDelete = this.loginService.hasPermission("MEDIATORS.DELETE");
  }

  public async loadData($event: any) {
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: $event.first + 1, size: $event.rows }
    };

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.mediatorsService.all(params));
    this.mediators = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(mediator: Mediator) {
    this.router.navigate(['mediators/' + (mediator && Object.keys(mediator).length > 0 ? mediator.id : 0)]);
  }

  delete(mediator: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el mediador?",
        header: "Eliminar mediador",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          
          this.mediatorsService.delete(mediator.id).subscribe({
            next: (data: any) => {
              if(mediator.userId){
                this.usersService.delete(mediator.userId).subscribe({
                  next: (data: any) => {      
                    this.messageService.add({ closable: true, severity: 'success', detail: "Mediador eliminado correctamente" });
                this.loadData(this.lastGridEvent);
                  },
                  error: (error: any) => {
                    this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
                  }
                });
              }else{
                this.messageService.add({ closable: true, severity: 'success', detail: "Mediador eliminado correctamente" });
                this.loadData(this.lastGridEvent);
              }
  
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
